import { useState } from 'react';

export function useNotification(timeout = 2000) {
  const [message, setMessage] = useState('');
  const [type, setType] = useState('success'); // or 'error'
  const [visible, setVisible] = useState(false);

  const notify = (msg, msgType = 'success') => {
    setMessage(msg);
    setType(msgType);
    setVisible(true);
    setTimeout(() => setVisible(false), timeout);
  };

  const Notification = () =>
    visible ? (
      <div
        className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-[200] w-fit max-w-[90%] px-6 py-4 rounded-md shadow border-l-4 ${
          type === 'error'
            ? 'bg-red-100 border-red-500 text-red-800'
            : 'bg-green-100 border-green-600 text-green-800'
        }`}
      >
        <strong className="block mb-1">
          {type === 'error' ? 'Error:' : 'Success:'}
        </strong>
        <span>{message}</span>
      </div>
    ) : null;

  return { notify, Notification };
}
